import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';

const DeleteButton = ({ icon = 'delete', onClick, title, text, isDisabled }) => {
  return (
    <button
      type="button"
      className="btn btn-md btn-theme-delete"
      onClick={isDisabled ? null : onClick}
      title={title}
      disabled={isDisabled}
    >
      <i className={`wb ${drapcodeIcon(icon)}`} /> {text}
    </button>
  );
};

export default DeleteButton;
